module.exports = __webpack_public_path__ + "img/img3.a0007f11.png";